import { Link } from "react-router-dom";
import { useT } from "@/lib/i18n";

export default function NotFound() {
  const { t, r } = useT();
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-6" data-testid="not-found-page">
      <img src="/emblem-square.png" alt="" className="w-28 h-28 rounded-full opacity-70" />
      <p className="mt-10 eyebrow">404</p>
      <h1 className="mt-4 text-3xl sm:text-4xl text-[#F3EFE6]">{t.nf_title}</h1>
      <Link to={r.home} className="btn-line mt-10" data-testid="not-found-home-link">{t.nf_back}</Link>
    </div>
  );
}
